import { useCallback, useMemo } from "preact/hooks";
import { useServices } from "@/services-context";
import { Url } from "@/helpers/url";
import { FORMATTER_LISTENER_NAME } from "@/services/formatter.ts";
import { CART_LISTENER_NAME } from "@/context/cart.ts";
import { Gtag } from "@/services/gtag.ts";
import {Templates, useTemplate} from "@/util-react/template.tsx";
import {CartDropdownDefault} from "@/elements-react/cart-control-dropdown/templates/cart-dropdown.default.tsx";
import {
  CartDropdownBlackAndBlue
} from "@/elements-react/cart-control-dropdown/templates/cart-dropdown.black-and-blue.tsx";
import React from "preact/compat";

export interface CartDropdownProps {
  count: number;
  label: string;
  toCart: () => void;
  hideTotal?: boolean;
  labelClassName?: string;
}

const templates: Record<Templates, React.ComponentType<CartDropdownProps>> = {
  [Templates.DEFAULT]: CartDropdownDefault,
  [Templates.BLACK_AND_BLUE]:  CartDropdownBlackAndBlue,
};

const CartControlDropdown = ({hideTotal = false, labelClassName = ''}: { hideTotal?: boolean, labelClassName?: string }) => {
  const template = useTemplate();
  const TemplatedComponent = templates[template.template] ?? templates.default;
  const services = useServices([CART_LISTENER_NAME, FORMATTER_LISTENER_NAME]);
  const count = services.cart.count;
  const total = services.cart.grandTotal?.amount;

  const toCart = useCallback(() => {
    Gtag.pushEvent("go_to_cart", "Cart Icon");
    Url.route(Url.to("cart-page"));
  }, []);

  const value = useMemo(() => {
    if (!total || total === '') {
      return 0;
    }

    return parseFloat(total);
  }, [total]);

  const label = useMemo(() => {
    return services.formatter.price(value, "full", false);
  }, [value]);

  const props = {
    count,
    label,
    toCart,
    hideTotal,
    labelClassName
  };

  return <TemplatedComponent {...props} />;
};

export default CartControlDropdown;
